import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useChat } from "@/components/chat/ChatProvider";
import { ChatList } from "@/components/chat/ChatList";
import { ChatThread } from "@/components/chat/ChatThread";
import { PresenceToggle } from "@/components/chat/PresenceToggle";
import { FunnelFilter } from "@/components/chat/ChatDock";
import { funnelOf } from "@/components/chat/ChatProvider";
import { MessagesSquare, Bot } from "lucide-react";

export default function Chat() {
  const { items, reload, aiEnabled } = useChat();
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState("open");
  const [done, setDone] = useState([]);
  const [fun, setFun] = useState("");
  const sid = params.get("s");
  const loadDone = () => api.get("/chat/sessions", { params: { status: "attended" } }).then((r) => setDone(r.data.items));
  useEffect(() => { if (tab === "attended") loadDone(); }, [tab]);
  const list = (tab === "open" ? items : done).filter((s) => !fun || funnelOf(s) === fun);

  return (
    <div data-testid="chat-page">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="flex items-center gap-2 text-3xl font-bold tracking-tight text-slate-100"><MessagesSquare className="h-7 w-7 text-sky-400" /> Chat do site</h1>
          <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500">
            Conversas do balão de atendimento.
            <span data-testid="chat-ai-status" className={aiEnabled ? "text-violet-300" : ""}><Bot className="mr-1 inline h-3.5 w-3.5" />IA {aiEnabled ? "ligada (Bia inicia todo atendimento)" : "desligada"}</span>
          </p>
        </div>
        <PresenceToggle />
      </div>
      <div className="flex h-[calc(100vh-190px)] min-h-[480px] overflow-hidden rounded-2xl border border-[#1F293D] bg-[#0F141F]">
        <div className={`w-full shrink-0 flex-col border-r border-[#1F293D] md:flex md:w-72 ${sid ? "hidden" : "flex"}`}>
          <div className="flex gap-1 border-b border-[#1F293D] p-2">
            {[["open", `Abertas (${items.length})`], ["attended", "Atendidas"]].map(([k, l]) => (
              <button key={k} data-testid={`chat-tab-${k}`} onClick={() => setTab(k)}
                className={`flex-1 rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${tab === k ? "bg-sky-500 text-slate-950" : "text-slate-400 hover:text-white"}`}>{l}</button>
            ))}
          </div>
          <div className="border-b border-[#1F293D] p-2"><FunnelFilter value={fun} onChange={setFun} /></div>
          <div className="flex-1 overflow-y-auto p-2">
            <ChatList items={list} active={sid} onPick={(id) => setParams({ s: id })} empty={tab === "open" ? "Nenhuma conversa aberta" : "Nenhuma conversa atendida ainda"} />
          </div>
        </div>
        <div className={`min-w-0 flex-1 flex-col ${sid ? "flex" : "hidden md:flex"}`}>
          {sid ? (
            <>
              <button data-testid="chat-back-btn" onClick={() => setParams({})} className="border-b border-[#1F293D] px-4 py-2 text-left text-xs text-sky-300 md:hidden">← Conversas</button>
              <ChatThread key={sid} sid={sid} wide onChanged={() => { reload(); if (tab === "attended") loadDone(); }}
                onDeleted={() => { setParams({}); reload(); if (tab === "attended") loadDone(); }} />
            </>
          ) : <div className="flex flex-1 items-center justify-center text-sm text-slate-500">Selecione uma conversa</div>}
        </div>
      </div>
    </div>
  );
}
